var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.matched.length)?_c('router-view'):_c('p',{attrs:{"role":"status"}},[_vm._v("正在加载页面并恢复登录，请稍候…")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }